export enum PracticeFeatureFlags {
  Billing = "billing",
}

export enum DevelopmentFeatureFlags {
  VerifyInsurance = "verify-insurance",
  EduResources = "edu-resources",
  PracticeBilling = "practice-billing",
  DotPhrases = "dot-phrases",
  Flags = "flags",
  NewbornPatientLinking = "newborn-patient-linking",
  ClientChartMessages = "client-chart-messages",
  OmniSearch = "omni-search",
}

/** Every current practice flag code, for checking which system a code belongs to. */
export const PRACTICE_FEATURE_FLAG_VALUES: ReadonlySet<string> = new Set(
  Object.values(PracticeFeatureFlags),
);

/** Every current development flag code, for checking which system a code belongs to. */
export const DEVELOPMENT_FEATURE_FLAG_VALUES: ReadonlySet<string> = new Set(
  Object.values(DevelopmentFeatureFlags),
);
